/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  
    // function runSwatchLogic() {

    //   // Run Only collection page 
    //   if (!document.body.classList.contains('template-collection')) return;

    //   document.querySelectorAll('.product-grid-item__swatch--siblings, .product-grid-item__swatch--grid, product-grid-item__fieldset').forEach(function(wrapper) {
        
    //     const swatches = Array.from(wrapper.querySelectorAll('.siblings__swatch, .swatch__button'));
    //     const max = 5;

    //     wrapper.querySelector('.siblings__more')?.remove();

    //     let activeIndex = swatches.findIndex(el => el.getAttribute('aria-current') === 'true');
    //     swatches.forEach(el => el.style.display = 'none');
    //     let visible = swatches.slice(0, max);

    //     if (activeIndex >= max) {
    //       visible.pop();
    //       visible.push(swatches[activeIndex]);
    //     }

    //     visible.forEach(el => el.style.display = 'inline-block');

    //     const remaining = swatches.length - visible.length;

    //     if (remaining > 0) {
    //       const more = document.createElement('div');
    //       more.className = 'siblings__more';
    //       more.textContent = '+' + remaining;

    //       more.addEventListener('click', function(e) {
          
    //         // swatches.forEach(el => el.style.display = 'inline-block');
    //         // more.remove(); 
    //           swatches.forEach(el => {
    //             el.style.display = ''; 
    //             el.classList.remove('is-hidden');
    //           });

    //           more.remove(); 
    //           console.log(swatches);
    //       });

    //       wrapper.appendChild(more);
    //     }
    //   });
    // }

    // document.addEventListener('DOMContentLoaded', function() {
    //   if (document.body.classList.contains('template-collection')) {
    //     setTimeout(runSwatchLogic, 500);
    //   }
    // });

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.querySelectorAll("[data-collapsible-trigger]").forEach((btn) => {
      btn.classList.remove("is-expanded");
      btn.setAttribute("aria-expanded", "false");

      const targetId = btn.getAttribute("aria-controls");
      const content = document.getElementById(targetId);

      if (content) {
        content.classList.remove("is-expanded");
        content.style.height = "0px";
      }
    });
  }, 200); 
});

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
